export default __webpack_public_path__ + "static/media/BGImage.6d5a6b65.jpg";